import config from '@/config'
import HttpRequest from './HttpRequest'

const request = new HttpRequest(config.API_PROXY)

export default request
